import { AxiosRequestConfig } from "axios";
import { config } from "@/utils/config/config.ts";

export const prepareRequest = function(zip: string): AxiosRequestConfig {
  const queryString = window.location.search;
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  const urlParams = new URLSearchParams(queryString);
  const destination = urlParams.get("type")
    ? urlParams.get("type")
    : "typeprojects";
  const request: AxiosRequestConfig = {
    method: "GET",
    url:
      config.appWordpressUrl +
      "/wp-json/zipcode-map-project/v1/addresses/" +
      zip +
      "/" +
      destination
  };
  return request;
};

export const prepareRequestApi = function(): AxiosRequestConfig {
  const request: AxiosRequestConfig = {
    method: "GET",
    url: config.appWordpressUrl + "/wp-json/zipcode-map-project/v1/google-key/"
  };
  return request;
};

export const prepareConfigs = function(): AxiosRequestConfig {
  const request: AxiosRequestConfig = {
    method: "GET",
    url: config.appWordpressUrl + "/wp-json/zipcode-map-project/v1/get-configs/"
  };
  return request;
};

export const prepareProjectTypes = function(): AxiosRequestConfig {
  const request: AxiosRequestConfig = {
    method: "GET",
    url:
      config.appWordpressUrl +
      "/wp-json/zipcode-map-project/v1/get-project-types/"
  };
  return request;
};
